import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RatingCollectorsPage } from './rating-collectors';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    RatingCollectorsPage,
  ],
  imports: [
  	TranslateModule,
    IonicPageModule.forChild(RatingCollectorsPage),
  ],
})
export class RatingCollectorsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/rating-collectors/rating-collectors.module.ts